import type Client from '../client'
import PaginatedResponse from '../paginated-response'
import type {
  ProductVariationResponse,
  RequestItemBag,
} from '@/api'

export default class ProductVariation {
  constructor(private client: Client) {}

  all(
    id: number | null,
    query: RequestItemBag = {},
  ): Promise<PaginatedResponse<ProductVariationResponse>> {
    return new Promise(async (resolve, reject) => {
      const url = id ? `product/${id}/product-variation` : 'product-variation'

      try {
        resolve(new PaginatedResponse(await this.client.get(url, { query })))
      } catch (error) {
        reject(error)
      }
    })
  }
}
